import { getLegalDocumentUrl } from '@fr/constants';

export function initLegalLinks(container = document) {
	const links = container.querySelectorAll('a[data-type]');

	links.forEach(link => {
		const docType = link.dataset.type;
		if (!docType) return;

		const actualUrl = getLegalDocumentUrl(docType);
		if (actualUrl) {
			link.setAttribute('href', actualUrl);
			link.setAttribute('target', '_blank');
			link.setAttribute('rel', 'noopener noreferrer');
		}
	});
}
